import React from 'react';
import { createPortal } from 'react-dom';
import useBodyScrollLock from '../../utils/useBodyScrollLock';
import './CommunitySelect.css';

const CommunityInfoModal = ({ community, onClose }) => {
  useBodyScrollLock(!!community);
  if (!community) return null;
  const modalContent = (
    <div className="modal-backdrop" onClick={e => e.target.className === 'modal-backdrop' && onClose()}>
      <div className="community-info-modal">
        <div className="modal-header">
          <h2>{community.title || 'Community Info'}</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        <div className="modal-content">
          {/* dump all community fields for debugging/info */}
          <pre className="community-info-dump">
            {JSON.stringify(community, null, 2)}
          </pre>
          
          {community.description && <p>{community.description}</p>}
          {community.rules && (
            <div>
              <h3>Rules</h3>
              <p>{community.rules}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );

  if (typeof document === 'undefined') {
    return modalContent;
  }

  return createPortal(modalContent, document.body);
};

export default CommunityInfoModal;